import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './text-field.module.scss';

interface TrailingActionProps {
  isPasswordField: boolean;
  passwordIcon: ReactNode;
  passwordAriaLabel: string;
  toggle: () => void;
  icon?: ReactNode;
  onIconClick?: () => void;
}

export const TrailingAction = ({
  isPasswordField,
  passwordIcon,
  passwordAriaLabel,
  toggle,
  icon,
  onIconClick,
}: TrailingActionProps) => {
  if (!isPasswordField && !icon) {
    return null;
  }

  const Tag = onIconClick || isPasswordField ? 'button' : 'div';
  const resolvedIcon = isPasswordField ? passwordIcon : icon;
  const handleClick = isPasswordField ? toggle : onIconClick;
  const ariaLabel = isPasswordField ? passwordAriaLabel : undefined;

  return (
    <Tag
      onClick={handleClick}
      aria-label={ariaLabel}
      className={clsx(
        styles['text-field-icon'],
        styles['text-field-icon-trailing'],
        (onIconClick || isPasswordField) &&
          styles['core-text-field-icon-button']
      )}
    >
      {resolvedIcon}
    </Tag>
  );
};
